import React from 'react';
import { Icon, Button } from '../../common';
import { getCategoryColor } from '../../../utils';
import type { WhatsAppBusinessData } from '../../../types/whatsapp';

export interface TemplatesTabProps {
  whatsappBusinessData: WhatsAppBusinessData;
  onGetTemplates: () => void;
  onCreateTemplate: (templateData: any) => void;
  onSendTemplate: (templateName: string, languageCode: string, phoneNumber: string) => void;
  onClearResponses: () => void;
}

export const TemplatesTab: React.FC<TemplatesTabProps> = ({
  whatsappBusinessData,
  onGetTemplates,
  onCreateTemplate,
  onSendTemplate,
  onClearResponses
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
          <Icon name="file-text" className="w-5 h-5" />
          Plantillas de Mensajes
        </h3>
        <div className="flex gap-2">
          <Button
            variant="primary"
            icon={whatsappBusinessData.templates_loading ? "loader" : "refresh-cw"}
            loading={whatsappBusinessData.templates_loading}
            onClick={onGetTemplates}
          >
            {whatsappBusinessData.templates_loading ? 'Cargando...' : 'Cargar Plantillas'}
          </Button>
          <Button
            variant="secondary"
            icon="plus"
            onClick={() => {/* TODO: Implement create template modal */}}
          >
            Nueva Plantilla
          </Button>
        </div>
      </div>

      {/* Templates Error */}
      {whatsappBusinessData.templates_error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2">
            <Icon name="x" className="w-5 h-5 text-red-600" />
            <span className="font-medium text-red-800">Error al cargar plantillas:</span>
          </div>
          <p className="text-red-700 text-sm mt-1">{whatsappBusinessData.templates_error}</p>
        </div>
      )}

      {/* Templates List */}
      {whatsappBusinessData.templates && whatsappBusinessData.templates.length > 0 && (
        <div className="space-y-4">
          {whatsappBusinessData.templates.map((template, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg p-4">
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-3">
                  <h4 className="font-medium text-gray-800">{template.name}</h4>
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${getCategoryColor(template.category)}`}>
                    {template.category}
                  </span>
                  <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
                    {template.status}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <Icon name="globe" className="w-4 h-4" />
                    <span>{template.language}</span>
                  </div>
                  {template.status === 'APPROVED' && (
                    <Button
                      size="small"
                      variant="secondary"
                      icon="play-circle"
                      onClick={() => {/* TODO: Implement send template */}}
                    >
                      Enviar
                    </Button>
                  )}
                </div>
              </div>
              
              {/* Template Components */}
              <div className="space-y-2 text-sm">
                {template.components?.map((component, compIndex) => (
                  <div key={compIndex} className="flex items-start gap-2">
                    <span className="text-gray-400 font-medium min-w-[60px]">
                      {component.type}:
                    </span>
                    <span className="text-gray-700">{component.text}</span>
                  </div>
                ))}
              </div>
              
              {/* Template ID */}
              <div className="mt-2 pt-2 border-t border-gray-100">
                <span className="text-xs text-gray-500 font-mono">ID: {template.id}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {!whatsappBusinessData.templates_loading && (!whatsappBusinessData.templates || whatsappBusinessData.templates.length === 0) && (
        <div className="text-center py-8">
          <Icon name="file-text" className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500">
            No hay plantillas disponibles. Haz clic en "Cargar Plantillas" para ver las existentes o "Nueva Plantilla" para crear una.
          </p>
        </div>
      )}
    </div>
  );
};